import { schema } from "normalizr";

export const simulatorState = new schema.Entity("simulatorStates");
